import React from 'react'
import { Container, Paper, Typography, Stack, Button, Alert, Box } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const Login: React.FC = () => {
  const nav = useNavigate()
  const [params] = useSearchParams()
  const redirectTo = params.get('redirect') || '/'
  const { login, ready, authenticated, error } = useAuth()
  const [submitting, setSubmitting] = React.useState(false)
  const [localError, setLocalError] = React.useState<string | null>(null)

  const [identifier, setIdentifier] = React.useState('')
  const [password, setPassword] = React.useState('')

  React.useEffect(() => {
    if (ready && authenticated) {
      nav(redirectTo, { replace: true })
    }
  }, [ready, authenticated, nav, redirectTo])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (submitting || !identifier || !password) return
    setSubmitting(true)
    setLocalError(null)
    try {
      await login(identifier, password)
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Login fehlgeschlagen'
      setLocalError(message)
    } finally {
      setSubmitting(false)
    }
  }

  const combinedError = localError || error

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper sx={{ p: 3 }} component="form" onSubmit={handleSubmit}>
        <Typography variant="h5" fontWeight={800} gutterBottom>Login</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>Bitte logge dich ein, um fortzufahren.</Typography>
        <Stack spacing={2}>
          {combinedError && <Alert severity="error">{combinedError}</Alert>}

          <Box>
            <Typography variant="body2" fontWeight={600} gutterBottom>Benutzername oder E-Mail</Typography>
            <Box
              component="input"
              type="text"
              required
              value={identifier}
              onChange={(e: any) => setIdentifier(e.target.value)}
              disabled={submitting || !ready}
              sx={{
                width: '100%',
                p: 1.5,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                bgcolor: 'background.paper',
                color: 'text.primary',
                fontSize: '1rem',
              }}
            />
          </Box>
          <Box>
            <Typography variant="body2" fontWeight={600} gutterBottom>Passwort</Typography>
            <Box
              component="input"
              type="password"
              required
              value={password}
              onChange={(e: any) => setPassword(e.target.value)}
              disabled={submitting || !ready}
              sx={{
                width: '100%',
                p: 1.5,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                bgcolor: 'background.paper',
                color: 'text.primary',
                fontSize: '1rem',
              }}
            />
          </Box>

          <Button variant="contained" type="submit" disabled={submitting || !ready}>
            {submitting ? 'Anmelden...' : 'Anmelden'}
          </Button>
        </Stack>
      </Paper>
    </Container>
  )
}

export default Login
